import { useQuery, type QueryClient } from '@tanstack/react-query';

import { type PaginationRequest } from '#packages/data-collection/utils/pagination';

import { AUDITS_QUERY_KEY } from '#apps/client-web/features/audit/types/react-query';
import {
  type AuditService,
  type CollectionName,
} from '#apps/client-web/features/audit/services/audit';

export const useAuditListQuery = ({
  auditService,
  queryClient,

  collectionName,
  pagination,
}: {
  auditService: AuditService;
  queryClient: QueryClient;

  collectionName: CollectionName;
  pagination: PaginationRequest;
}) =>
  useQuery(
    {
      queryKey: [AUDITS_QUERY_KEY, pagination],
      queryFn: auditService.loadAll.bind(auditService, {
        collectionName,
        pagination,
      }),
    },
    queryClient,
  );
